<template>
  <header class="main-header">
    <div class="main-header-content">

      <div class="title-container">
        <div class="menu-container" @click="$emit('showMobileNav')">
          <HamburgerMenu v-if="isLoggedIn()" />
        </div>

        <div class="nav-container">
          <div class="title" @click="routeToHome">
            <Logo />
          </div>

          <nav v-if="isLoggedIn()">
            <router-link tag="div" class="tab" to="/projects">
              <UsersIcon />
              <div>Users</div>
            </router-link>

            <router-link tag="div" class="tab" to="/devices">
              <DevicesIcon />
              <div>Devices</div>
            </router-link>
          </nav>
        </div>

        <div class="blank-column"></div>
      </div>

      <Button
        v-if="isLoggedIn()"
        v-bind:title="'Log Off'"
        v-bind:type="'raised'"
        v-bind:colorTheme="'primary'"
        v-on:button-click="logOut"
      />

    </div>
  </header>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Logo from '@/components/assets/Logo.vue'
import DevicesIcon from '@/components/assets/DevicesIcon.vue'
import UsersIcon from '@/components/assets/UsersIcon.vue'
import HamburgerMenu from '@/components/assets/HamburgerMenu.vue'
import Button from '@/components/form-elements/Button';

export default {
  name: 'Header',
  components: {
    Logo,
    Button,
    HamburgerMenu,
    UsersIcon,
    DevicesIcon
  },
  methods: {
    logOut() {
      firebase.auth().signOut()
        .then(() => this.$router.replace({ name: 'login' }))
        .catch((error) => console.log(error))
    },
    isLoggedIn() {
      return firebase.auth().currentUser
    },
    routeToHome() {
      this.$router.replace({ name: 'projects' })
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/colors';
@import '../assets/styles/mixin';

.main-header-content {
  @include flex(column, space-around, center);
  max-width: 1024px;
  height: 100%;
  margin: 0 auto;
  padding: 0 8px;
}

.main-header {
  @include default_shadow(4px);
  background: #fff;
  height: 80px;
}

.title-container {
  @include flex(row, space-around, center);
  width: 100%;

  svg {
    cursor: pointer;
  }
}

nav {
  display: none;
}

.title {
  @include flex(row, center, center);

  svg {
    margin-left: 8px;
  }
}

h1 {
  margin: 0;
  font-family: 'Shrikhand', cursive;
  font-size: 18px;
  font-weight: normal;
  color: $gd-gray;
}

button {
  display: none
}

.blank-column {
  width: 24px;
}

@media (min-width: 600px) {
  .main-header-content {
    @include flex(row, space-between, center);
  }

  .title-container {
    @include flex(row, flex-start, center);
    width: 50%;
    height: 100%;
  }

  .nav-container {
    @include flex(row, flex-start, center);
    height: 100%;
  }

  .title {
    margin-right: 48px;
  }

  nav {
    @include flex(row, center, flex-end);
    height: 100%;
  }

  .tab {
    @include flex(column, center, center);
    width: 75px;
    height: 63px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: pointer;

    &.router-link-active {
      background-color: $primary-shadow;

      svg, div {
        fill-opacity: 0.87;
      }
    }
  }

  .blank-column, .hamburger-menu {
    display: none;
  }

  button {
    display: block;
  }
}

@media (min-width: 1024px) {
  .main-header-content {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue